import { User } from '../gen/models'

/**
 * #7806 — a user row carries a cloak when EITHER marker is set: hospital cloaks set both,
 * supplier-customer cloaks set cloakCustomerId only.
 */
export const isCloakedUser = (user?: Pick<User, 'cloakUserId' | 'cloakCustomerId'> | null): boolean =>
  !!user && (!!user.cloakUserId || !!user.cloakCustomerId)

/** #7806 — the supplier-customer shape specifically (identity kept, customer swapped). */
export const isCustomerCloak = (user?: Pick<User, 'cloakUserId' | 'cloakCustomerId'> | null): boolean =>
  !!user && !!user.cloakCustomerId && !user.cloakUserId
